import type {
  GeneralUpdate,
  PersonContact,
  PersonContactGetResponse,
  PersonGeneralGetResponse,
  RelatedPerson,
  RelatedPersonGetAllResponse,
  RelatedPersonGetResponse,
  RelatedPersonSearchParams,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class NextOfKinApi {
  public async createNextOfKin(
    body: RelatedPerson,
  ): Promise<RelatedPersonGetResponse> {
    return await trpcClient.relatedPerson.create.mutate(body);
  }

  public async updateContactNextOfKin(
    id: string,
    body: PersonContact,
  ): Promise<PersonContactGetResponse> {
    return await trpcClient.relatedPerson.updateContact.mutate({
      id,
      contact: body,
    });
  }

  public async updateGeneralNextOfKin(
    params: GeneralUpdate,
  ): Promise<PersonGeneralGetResponse> {
    return await trpcClient.relatedPerson.updateGeneral.mutate(params);
  }

  public async getAllNextOfKin(
    params: RelatedPersonSearchParams,
  ): Promise<RelatedPersonGetAllResponse> {
    return await trpcClient.relatedPerson.getAll.query(params);
  }
}
